import FilterGroupService from 'www/modules/Filters/service/filter-group-types/FilterGroupService'
import FilterGroupPlace from 'www/modules/Filters/common/filter-group-types/FilterGroupPlace'
import SnackbarNotificationMixin from 'www/vue_components/common/core/SnackbarNotification/SnackbarNotificationMixin'

export default {
  name: 'ServiceFiltersMixin',
  mixins: [
    SnackbarNotificationMixin,
  ],
  props: {
    services: {
      type: Array,
      default: () => [],
    },
    metros: {
      type: Array,
      default: () => [],
    },
    districts: {
      type: Array,
      default: () => [],
    },
    initialService: {
      type: String,
      default: '',
    },
    initialSort: {
      type: String,
      default: '',
    },
    initialRegion: {
      type: String,
      default: '',
    },
    filteredCount: {
      type: [Number, String],
      default: null,
    },
    updating: {
      type: Boolean,
      default: false,
    },
    isEnabledIndexOnMetroAndArea: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      serviceFilters: this.initServiceFilters(),
      placeFilters: this.initPlaceFilters(),
    }
  },
  computed: {
    anyServiceFilterApplied() {
      return this.serviceFilters.isAnyApplied()
    },
    anyPlaceFilterApplied() {
      return this.placeFilters.isAnyApplied()
    },
  },
  watch: {
    serviceFilters: {
      deep: true,
      handler() {
        if (!this.updating) {
          this.submitFilter()
        }
      },
    },
    placeFilters: {
      deep: true,
      handler(newValue) {
        if (!this.isEnabledIndexOnMetroAndArea) {
          if (newValue.region.value !== 'any') {
            this.replaceMetaRobots('noindex, nofollow')
          } else {
            this.replaceMetaRobots('all')
          }
        }

        if (!this.updating) {
          this.submitFilter()
        }
      },
    },
  },
  created() {
    const allFilters = { ...this.serviceFilters, ...this.placeFilters }

    this.$emit('init', allFilters)
  },
  methods: {
    initServiceFilters() {
      const filterOptions = {
        service: {
          list: this.services,
          initial: this.initialService,
        },
        sort: { initial: this.initialSort },
      }

      return new FilterGroupService(filterOptions)
    },
    handleServiceFiltersReset() {
      this.serviceFilters.resetFilters()
      this.showNotification({ message: 'Фильтры сброшены.', upper: true })
    },
    handleServiceFiltersSubmit(data) {
      this.serviceFilters.setFilters(data)
    },
    handleServiceFiltersClose() {
      this.closeAllDialogs()
    },
    initPlaceFilters() {
      const filterOptions = {
        region: {
          list: [...this.metros, ...this.districts],
          initial: this.initialRegion,
        },
      }

      return new FilterGroupPlace(filterOptions)
    },
    handlePlaceFiltersReset() {
      this.placeFilters.resetFilters()
      this.showNotification({ message: 'Фильтры сброшены.', upper: true })
    },
    handlePlaceFiltersSubmit(data) {
      this.placeFilters.setFilters(data)
    },
    handlePlaceFiltersClose() {
      this.closeAllDialogs()
    },
    submitFilter() {
      const allFilters = { ...this.serviceFilters, ...this.placeFilters }

      this.$emit('update:page', allFilters)
    },
    replaceMetaRobots(value) {
      const metaNode = document.querySelector('[name="robots"]')

      if (metaNode) {
        metaNode.setAttribute('content', value)
      } else {
        const metaNodeCreated = document.createElement('meta')

        metaNodeCreated.setAttribute('name', 'robots')
        metaNodeCreated.setAttribute('content', value)

        document.head.append(metaNodeCreated)
      }
    },
  },
}
